export const EVENT_LOG_TYPE = {
  INFLOW_PATH: 'INFLOW_PATH',
};
